export const createFetchCompanyInfoSlice = (set, get) => ({
    isFetchingCompanyInfo: false,
    
    setIsFetchingCompanyInfo: (value) =>
      set(() => ({
        isFetchingCompanyInfo: value,
      })),
    
    getIsFetchingCompanyInfo: () => get().isFetchingCompanyInfo,
  });